import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form, Label } from '@anytag/shared-atoms';
import { formatNumber } from '@anytag/shared-utils';
import { MarketplaceFormValues } from '../types';
import { calculateInfluencerCommissionRate } from '../utils';

export const InfluencerCommissionRateField = () => {
  const { t } = useTranslation();
  const { getValues } = useFormContext<MarketplaceFormValues>();

  const { marginRate, costPerSaleTune, costPerSaleReferral } = getValues();
  const influencerCommissionRate = calculateInfluencerCommissionRate({
    marginRate,
    costPerSaleTune,
    costPerSaleReferral
  });

  return (
    <Form.Field>
      <Label
        className="mb-2 p-0"
        help={t('Tooltip.influencerCommissionRateHelp')}
        title={t('TextForm.Influencer Commission Rate')}
      />
      <p css={{ fontSize: '14px' }}>{formatNumber(influencerCommissionRate)}%</p>
    </Form.Field>
  );
};
